import { DragOutlined } from "@ant-design/icons"
import { Button, Modal, Row, Col, Table, message } from "antd"
import React, { useState } from "react"
import { sequenceCols } from "./ArsomaTableColumns"
import { DndContext } from "@dnd-kit/core"
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { doc, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"

const OneRow = (props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props["data-row-key"],
  })
  const style = {
    ...props.style,
    transform: CSS.Transform.toString(
      transform && {
        ...transform,
        scaleY: 1,
      }
    ),
    transition,
    cursor: "move",
    ...(isDragging
      ? {
          position: "relative",
          zIndex: 9999,
        }
      : {}),
  }
  return <tr {...props} ref={setNodeRef} style={style} {...attributes} {...listeners} />
}
const CutterSequence = ({ tableLoading, setVivaData, vivaData, setVivaSequence, vivaSequence }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  const updateArsomaSequence = async () => {
    const ref = doc(db, "sequence", "bpIeedOJcahszryHT9lr")
    try {
      updateDoc(ref, {
        cutterSequence: vivaSequence,
      }).then(() => {
        message.success("updated!")
        setIsModalOpen(false)
      })
    } catch (error) {
      console.log(error.message)
      message.error(error)
    }
  }

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setVivaData((prev) => {
        const activeIndex = prev.findIndex((i) => i.key === active.id)
        const overIndex = prev.findIndex((i) => i.key === over?.id)
        const newArsomaData = arrayMove(prev, activeIndex, overIndex)
        const newIdOrder = newArsomaData.map((item) => item.id)
        setVivaSequence(newIdOrder)
        return newArsomaData
      })
    }
  }

  return (
    <>
      <Button onClick={showModal} type="primary">
        <DragOutlined /> Manage Sequence
      </Button>
      <Modal
        width={1500}
        title="Sequence Manager"
        open={isModalOpen}
        onOk={updateArsomaSequence}
        onCancel={handleCancel}>
        <Row>
          <Col span={24}>
            <DndContext onDragEnd={onDragEnd}>
              <SortableContext
                // rowKey array
                items={vivaData.map((i) => i.key)}
                strategy={verticalListSortingStrategy}>
                <Table
                  style={{ marginTop: "15px" }}
                  size="small"
                  loading={tableLoading}
                  columns={sequenceCols}
                  dataSource={vivaData}
                  rowKey={(record) => record.id}
                  pagination={{ defaultPageSize: "12", showSizeChanger: true }}
                  components={{
                    body: {
                      row: OneRow,
                    },
                  }}
                />
              </SortableContext>
            </DndContext>
          </Col>
        </Row>
      </Modal>
    </>
  )
}
export default CutterSequence
